// src/components/SidebarSubItem.jsx
import "./Sidebar.scss";

import { Collapse, Nav } from "react-bootstrap";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { isPathActive } from "./sidebarActive";

const SidebarSubItem = ({
  label,
  path,
  isRoute,
  children,
  handleClose,
  unreadCount,
  isNew,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const hasChildren = !!children?.length;

  const anyChildActive = useMemo(() => {
    if (!hasChildren) return false;
    return children.some((c) => isPathActive(location.pathname, c.path));
  }, [children, hasChildren, location.pathname]);

  const selfActive = useMemo(() => isPathActive(location.pathname, path), [location.pathname, path]);

  // ✅ Pai fica ativo se: ele próprio está ativo OU algum filho está ativo
  const parentActive = hasChildren ? (selfActive || anyChildActive) : selfActive;

  // ✅ Expande automaticamente quando estiver em alguma rota filha
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (hasChildren && parentActive) setOpen(true);
  }, [hasChildren, parentActive]);

  const go = (p) => {
    navigate(p);
    handleClose?.();
  };

  if (!hasChildren) {
    return (
      <div className={`hc-side-item ${parentActive ? "is-active" : ""}`}>
        <Nav.Item>
          <Nav.Link onClick={() => go(path)} className="nav-link hc-side-item__link">
            <i className="bi bi-grid-fill hc-side-item__icon" />
            <span className="hc-side-item__text">
              {label}
              {isNew ? <span className="hc-side-badge">NOVO</span> : null}
              {label === "Notificações" && Number(unreadCount) > 0 ? (
                <span className="hc-side-pill">{unreadCount}</span>
              ) : null}
            </span>
          </Nav.Link>
        </Nav.Item>
      </div>
    );
  }

  return (
    <div className={`hc-side-group ${parentActive ? "is-active" : ""}`}>
      <div
        className="hc-side-group__header"
        role="button"
        tabIndex={0}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setOpen((v) => !v);
        }}
      >
        <div className="hc-side-group__left">
          <i className="bi bi-folder2-open hc-side-item__icon" />
          <span className="hc-side-item__text">
            {label}
            {isNew ? <span className="hc-side-badge">NOVO</span> : null}
          </span>
        </div>
        <i className={`bi ${open ? "bi-chevron-up" : "bi-chevron-down"} hc-side-group__chev`} />
      </div>

      <Collapse in={open}>
        <div className="hc-side-group__children">
          {(children || []).map((c) => {
            const childActive = isPathActive(location.pathname, c.path);
            return (
              <div key={`${label}-${c.path}`} className={`hc-side-child ${childActive ? "is-active" : ""}`}>
                <Nav.Item>
                  <Nav.Link onClick={() => go(c.path)} className="nav-link hc-side-child__link">
                    <span className="hc-side-child__dot" />
                    <span className="hc-side-child__text">{c.label}</span>
                  </Nav.Link>
                </Nav.Item>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
};

export default SidebarSubItem;
